module.exports = __webpack_public_path__ + "static/media/21ECLAC11.0a8e8bc2.jpg";